import { useCategoriaProductoStore, userPromocionesStore } from "@/store/erp";
import { usePaymentMethodsStore } from "@/store/erp/system-settings/payment-methods";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function VentasPymesModule() {

  const getPromociones = userPromocionesStore(s => s.getPromociones);
  const getpaymentMethodsFilterPaging = usePaymentMethodsStore(s => s.getpaymentMethodsFilterPaging);
  const getPlans = usePlanStore(s => s.getPlans);
  const getTypeInstalation = useTypeInstalation(s => s.getTypeInstalation);
  const getCategoriaProducto = useCategoriaProductoStore(s => s.getCategoriaProducto);

  useEffect(() => {

    (async () => {
      const results = await Promise.allSettled([
        getPromociones(),
        getPlans({
          page_size: 300,
          estado: true
        }),
        getTypeInstalation({
          page_size: 600,
          estado: true
        }),
        getpaymentMethodsFilterPaging({
          page_size: 600,
          estado: true
        }),
        getCategoriaProducto({
          page_size: 600,
          estado: true
        }),
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);

  return <Outlet />

}

